var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:google-calendar",
    clipPath: "url(#clip0_944_1304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5526 5.94727H5.44739V18.0525H17.5526V5.94727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5526 23.5L23.0001 18.0526L20.2764 17.5879L17.5526 18.0526L17.0555 20.5439L17.5526 23.5Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 18.0526V21.6841C0 22.6874 0.812547 23.5 1.81574 23.5H5.44741L6.00668 20.7763L5.44741 18.0526L2.4796 17.5879L0 18.0526Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.0001 5.94741V2.31574C23.0001 1.31255 22.1875 0.5 21.1843 0.5H17.5526C17.2213 1.85089 17.0555 2.84501 17.0555 3.48245C17.0555 4.1198 17.2213 4.94152 17.5526 5.94741C18.7575 6.29241 19.6653 6.46491 20.2764 6.46491C20.8874 6.46491 21.7952 6.29241 23.0001 5.94741Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23 5.94727H17.5526V18.0525H23V5.94727Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.5526 18.0527H5.44739V23.5001H17.5526V18.0527Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.5526 0.5H1.81583C0.812547 0.5 0 1.31255 0 2.31574V18.0526H5.44741V5.94741H17.5526V0.5Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.93048 15.3378C7.47803 15.0321 7.16475 14.5858 6.99377 13.9955L8.04396 13.5628C8.13919 13.926 8.30567 14.2075 8.54331 14.4072C8.77933 14.6069 9.06683 14.7053 9.40275 14.7053C9.74623 14.7053 10.0413 14.6009 10.2879 14.392C10.5346 14.1832 10.6587 13.9169 10.6587 13.5946C10.6587 13.2647 10.5285 12.9954 10.2683 12.7866C10.008 12.5778 9.68118 12.4734 9.29081 12.4734H8.684V11.4339H9.22873C9.56465 11.4339 9.84757 11.3431 10.0776 11.1614C10.3076 10.9799 10.4226 10.7317 10.4226 10.4154C10.4226 10.134 10.3197 9.91005 10.114 9.74214C9.90822 9.57413 9.64785 9.48941 9.3316 9.48941C9.0229 9.48941 8.7778 9.57116 8.59623 9.73603C8.41475 9.90141 8.27832 10.1102 8.19975 10.3428L7.16025 9.91005C7.2979 9.51968 7.55063 9.17468 7.92132 8.87658C8.29211 8.57848 8.76567 8.42871 9.34067 8.42871C9.7659 8.42871 10.1487 8.51047 10.4877 8.67533C10.8266 8.84029 11.0929 9.06876 11.2851 9.35931C11.4773 9.6513 11.5726 9.97816 11.5726 10.3413C11.5726 10.712 11.4834 11.0253 11.3048 11.2825C11.1262 11.5397 10.9068 11.7364 10.6466 11.8741V11.9361C10.9826 12.0747 11.2745 12.3023 11.4909 12.5944C11.7103 12.8895 11.8208 13.242 11.8208 13.6537C11.8208 14.0651 11.7163 14.4329 11.5075 14.7551C11.2987 15.0775 11.0098 15.3317 10.6435 15.5163C10.2759 15.7009 9.86275 15.7948 9.40428 15.7948C8.87313 15.7963 8.38294 15.6434 7.93048 15.3378ZM14.3809 10.1264L13.2279 10.9601L12.6514 10.0856L14.7199 8.59357H15.5128V15.6313H14.3809V10.1264Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_1304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendarIcon);
export default __webpack_public_path__ + "static/media/google-calendar-icon.f4ed9bedff64bd03a48d81e9ffb77f9e.svg";
export { ForwardRef as ReactComponent };